<template>
  <div>
    <section id="faqs" class="section pt-1 bg-white">
      <div class="container">
        <h1 class="media">
          <div class="avatar-sm mr-3">
            <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-28">
              <i class="bx bxs-help-circle"></i>
            </span>
          </div>
          {{ $t("help.faqs.frequently-asked-questions.title") }}
        </h1>

        <!-- Faqs start -->
        <section class="section" id="faqs">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <div class="vertical-nav">
                  <!--Tab Category Start-->
                  <b-tabs pills vertical nav-wrapper-class="col-lg-2 col-sm-4">
                    <b-tab :active="!cat || cat == 'cat1'">
                      <template v-slot:title>
                        <i class="bx bx-help-circle nav-icon d-block mb-2"></i>
                        <p class="font-weight-bold mb-0">
                          {{ $t("help.faqs.questions") }}
                        </p>
                      </template>
                      <b-card-text>
                        <div class="card">
                          <div class="card-body">
                            <h4 class="card-title mb-4">
                              {{ $t("help.faqs.questions") }}
                            </h4>
                            <div role="tablist">
                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list" :class="col == 'col1_1' ? 'founded' : ''" v-b-toggle="'col1_1'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-1.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_1" :visible="col == 'col1_1'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <b-card-text>
                                      <p class="mb-0">
                                        {{ $t("help.faqs.frequently-asked-questions.question-1.answer-part-1") }}
                                        <br /><br />
                                      </p>

                                      <p v-if="currentAccountCan('HELP_CENTER_FAQS__TEMPLATE_1')">
                                        <a href="/organization/members">
                                          <i class="bx bx-support"></i>
                                          {{ $t("help.faqs.frequently-asked-questions.question-1.answer-part-2") }}
                                        </a>
                                      </p>
                                    </b-card-text>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1_2' ? 'founded' : ''" v-b-toggle="'col1_2'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-2.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_2" :visible="col == 'col1_2'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p class="mb-0">{{ $t("help.faqs.frequently-asked-questions.question-2.answer-part-1") }}<br /><br /></p>

                                    <p>
                                      <a href="/forgot-password">
                                        <i class="bx bx-support"></i>
                                        {{ $t("help.faqs.frequently-asked-questions.question-2.answer-part-2") }}
                                      </a>
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1_3' ? 'founded' : ''" v-b-toggle="'col1_3'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-3.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_3" :visible="col == 'col1_3'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p class="mb-0">
                                      {{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-1") }}
                                      <br /><br />
                                      {{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-2") }}
                                      <br /><br />
                                    </p>
                                    <h4>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-3") }}</h4>
                                    <ul>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-4") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-5") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-6") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-7") }}</li>
                                    </ul>
                                    <h4>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-8") }}</h4>
                                    <ul>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-9") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-10") }}</li>
                                    </ul>
                                    <h4>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-11") }}</h4>
                                    <ul>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-12") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-13") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-14") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-15") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-16") }}</li>
                                    </ul>
                                    <h4>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-17") }}</h4>
                                    <ul>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-18") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-19") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-20") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-21") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-22") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-23") }}</li>
                                    </ul>
                                    <h4>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-24") }}</h4>
                                    <ul>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-25") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-26") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-27") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-28") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-29") }}</li>
                                    </ul>
                                    <h4>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-30") }}</h4>
                                    <ul>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-31") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-32") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-33") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-34") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-35") }}</li>
                                    </ul>
                                    <h4>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-36") }}</h4>
                                    <ul>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-37") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-38") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-39") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-40") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-41") }}</li>
                                    </ul>
                                    <h4>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-42") }}</h4>
                                    <ul>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-43") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-44") }}</li>
                                    </ul>
                                    <h4>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-45") }}</h4>
                                    <ul>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-46") }}</li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-47") }}</li>
                                    </ul>

                                    <p v-if="currentAccountCan('HELP_CENTER_FAQS__TEMPLATE_2')">
                                      <a href="/organization/members">
                                        <i class="bx bx-support"></i>
                                        {{ $t("help.faqs.frequently-asked-questions.question-3.answer-part-48") }}
                                      </a>
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>

                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list" :class="col == 'col1_4' ? 'founded' : ''" v-b-toggle="'col1_4'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-4.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_4" :visible="col == 'col1_4'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <b-card-text>
                                      <p class="mb-0">
                                        {{ $t("help.faqs.frequently-asked-questions.question-4.answer-part-1") }}
                                      </p>
                                    </b-card-text>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>

                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list" :class="col == 'col1_5' ? 'founded' : ''" v-b-toggle="'col1_5'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-5.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_5" :visible="col == 'col1_5'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <b-card-text>
                                      <p class="mb-0">
                                        {{ $t("help.faqs.frequently-asked-questions.question-5.answer-part-1") }}
                                      </p>
                                      <br />
                                      <ul>
                                        <li>
                                          <h4>{{ $t("help.faqs.frequently-asked-questions.question-5.answer-part-2") }}</h4>
                                        </li>
                                      </ul>
                                      {{ $t("help.faqs.frequently-asked-questions.question-5.answer-part-3") }}
                                      <br />
                                      <br />
                                      <ul>
                                        <li>
                                          <h4>{{ $t("help.faqs.frequently-asked-questions.question-5.answer-part-4") }}</h4>
                                        </li>
                                      </ul>
                                      {{ $t("help.faqs.frequently-asked-questions.question-5.answer-part-5") }}
                                    </b-card-text>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>

                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1_6' ? 'founded' : ''" v-b-toggle="'col1_6'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-6.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_6" :visible="col == 'col1_6'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p class="mb-3">
                                      {{ $t("help.faqs.frequently-asked-questions.question-6.answer-part-1") }}
                                    </p>

                                    <p>
                                      <a href="/organization/hierarchy">
                                        <i class="bx bx-support"></i>
                                        {{ $t("help.faqs.frequently-asked-questions.question-6.answer-part-2") }}
                                      </a>
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>

                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list" :class="col == 'col1_7' ? 'founded' : ''" v-b-toggle="'col1_7'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-7.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_7" :visible="col == 'col1_7'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <b-card-text>
                                      <p class="mb-0">
                                        {{ $t("help.faqs.frequently-asked-questions.question-7.answer-part-1") }}
                                      </p>
                                      <p>
                                        <a href="/kvkk/inventory">
                                          <i class="bx bx-support"></i>
                                          {{ $t("help.faqs.frequently-asked-questions.question-7.answer-part-2") }}
                                        </a>
                                      </p>
                                    </b-card-text>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>

                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list" :class="col == 'col1_8' ? 'founded' : ''" v-b-toggle="'col1_8'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-8.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_8" :visible="col == 'col1_8'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p class="mb-3">
                                      {{ $t("help.faqs.frequently-asked-questions.question-8.answer-part-1") }}
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>

                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1_9' ? 'founded' : ''" v-b-toggle="'col1_9'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-9.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_9" :visible="col == 'col1_9'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <ul>
                                      <li>
                                        {{ $t("help.faqs.frequently-asked-questions.question-9.answer-part-1") }}
                                      </li>
                                      <li>{{ $t("help.faqs.frequently-asked-questions.question-9.answer-part-2") }}</li>
                                    </ul>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1_10' ? 'founded' : ''" v-b-toggle="'col1_10'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-10.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_10" :visible="col == 'col1_10'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p>
                                      {{ $t("help.faqs.frequently-asked-questions.question-10.answer-part-1") }}
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1_11' ? 'founded' : ''" v-b-toggle="'col1_11'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-11.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_11" :visible="col == 'col1_11'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p>
                                      {{ $t("help.faqs.frequently-asked-questions.question-11.answer-part-1") }}
                                    </p>
                                    <p>
                                      <a href="/kvkk/risk">
                                        <i class="bx bx-support"></i>
                                        {{ $t("help.faqs.frequently-asked-questions.question-11.answer-part-2") }}
                                      </a>
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1_12' ? 'founded' : ''" v-b-toggle="'col1_12'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-12.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_12" :visible="col == 'col1_12'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p>
                                      {{ $t("help.faqs.frequently-asked-questions.question-12.answer-part-1") }}
                                    </p>
                                    <p>
                                      <a href="/risk/corporate-risk">
                                        <i class="bx bx-support"></i>
                                        {{ $t("help.faqs.frequently-asked-questions.question-12.answer-part-2") }}
                                      </a>
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1_13' ? 'founded' : ''" v-b-toggle="'col1_13'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-13.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_13" :visible="col == 'col1_13'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p>
                                      {{ $t("help.faqs.frequently-asked-questions.question-13.answer-part-1") }}
                                    </p>
                                    <p>
                                      <a href="/organization/asset-groups">
                                        <i class="bx bx-support"></i>
                                        {{ $t("help.faqs.frequently-asked-questions.question-13.answer-part-2") }}
                                      </a>
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1_14' ? 'founded' : ''" v-b-toggle="'col1_14'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-14.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_14" :visible="col == 'col1_14'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p>
                                      {{ $t("help.faqs.frequently-asked-questions.question-14.answer-part-1") }}
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1_15' ? 'founded' : ''" v-b-toggle="'col1_15'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-15.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_15" :visible="col == 'col1_15'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p>
                                      {{ $t("help.faqs.frequently-asked-questions.question-15.answer-part-1") }}
                                    </p>
                                    <br />
                                    <p>{{ $t("help.faqs.frequently-asked-questions.question-15.answer-part-2") }}</p>
                                    <br />
                                    <ul>
                                      <li>
                                        <p>{{ $t("help.faqs.frequently-asked-questions.question-15.answer-part-3") }}</p>
                                      </li>
                                      <li>
                                        <p>{{ $t("help.faqs.frequently-asked-questions.question-15.answer-part-4") }}</p>
                                      </li>
                                      <li>
                                        <p>{{ $t("help.faqs.frequently-asked-questions.question-15.answer-part-5") }}</p>
                                      </li>
                                    </ul>
                                    <br />
                                    <p>{{ $t("help.faqs.frequently-asked-questions.question-15.answer-part-6") }}</p>
                                    <p>
                                      <a href="/organization/policy">
                                        <i class="bx bx-support"></i>
                                        {{ $t("help.faqs.frequently-asked-questions.question-15.answer-part-7") }}
                                      </a>
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1_16' ? 'founded' : ''" v-b-toggle="'col1_16'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-16.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_16" :visible="col == 'col1_16'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p>
                                      {{ $t("help.faqs.frequently-asked-questions.question-16.answer-part-1") }}
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1_17' ? 'founded' : ''" v-b-toggle="'col1_17'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-17.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_17" :visible="col == 'col1_17'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p>
                                      {{ $t("help.faqs.frequently-asked-questions.question-17.answer-part-1") }}
                                    </p>

                                    <p>
                                      <a href="/organization/policy">
                                        <i class="bx bx-support"></i>
                                        {{ $t("help.faqs.frequently-asked-questions.question-17.answer-part-2") }}
                                      </a>
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1_18' ? 'founded' : ''" v-b-toggle="'col1_18'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-18.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_18" :visible="col == 'col1_18'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p>
                                      {{ $t("help.faqs.frequently-asked-questions.question-18.answer-part-1") }}
                                    </p>

                                    <p>
                                      <a href="/organization/policy">
                                        <i class="bx bx-support"></i>
                                        {{ $t("help.faqs.frequently-asked-questions.question-18.answer-part-2") }}
                                      </a>
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1_19' ? 'founded' : ''" v-b-toggle="'col1_19'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-19.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_19" :visible="col == 'col1_19'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p>
                                      {{ $t("help.faqs.frequently-asked-questions.question-19.answer-part-1") }}
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1_20' ? 'founded' : ''" v-b-toggle="'col1_20'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-20.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_20" :visible="col == 'col1_20'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p>
                                      {{ $t("help.faqs.frequently-asked-questions.question-20.answer-part-1") }}
                                    </p>

                                    <p>
                                      <a href="/organization/file-manager">
                                        <i class="bx bx-support"></i>
                                        {{ $t("help.faqs.frequently-asked-questions.question-20.answer-part-2") }}
                                      </a>
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1_21' ? 'founded' : ''" v-b-toggle="'col1_21'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-21.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_21" :visible="col == 'col1_21'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p>
                                      {{ $t("help.faqs.frequently-asked-questions.question-21.answer-part-1") }}
                                    </p>

                                    <p>
                                      <a href="/organization/file-manager">
                                        <i class="bx bx-support"></i>
                                        {{ $t("help.faqs.frequently-asked-questions.question-21.answer-part-2") }}
                                      </a>
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1_22' ? 'founded' : ''" v-b-toggle="'col1_22'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-22.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_22" :visible="col == 'col1_22'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p>
                                      {{ $t("help.faqs.frequently-asked-questions.question-22.answer-part-1") }}
                                    </p>

                                    <p>
                                      <a href="/organization/file-manager">
                                        <i class="bx bx-support"></i>
                                        {{ $t("help.faqs.frequently-asked-questions.question-22.answer-part-2") }}
                                      </a>
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1_23' ? 'founded' : ''" v-b-toggle="'col1_23'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-23.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_23" :visible="col == 'col1_23'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p>
                                      {{ $t("help.faqs.frequently-asked-questions.question-23.answer-part-1") }}
                                    </p>

                                    <p>
                                      <a href="/kvkk/legal-document-template">
                                        <i class="bx bx-support"></i>
                                        {{ $t("help.faqs.frequently-asked-questions.question-23.answer-part-2") }}
                                      </a>
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1_24' ? 'founded' : ''" v-b-toggle="'col1_24'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-24.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_24" :visible="col == 'col1_24'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p>
                                      {{ $t("help.faqs.frequently-asked-questions.question-24.answer-part-1") }}
                                    </p>

                                    <p>
                                      <a href="/kvkk/report">
                                        <i class="bx bx-support"></i>
                                        {{ $t("help.faqs.frequently-asked-questions.question-24.answer-part-2") }}
                                      </a>
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1_25' ? 'founded' : ''" v-b-toggle="'col1_25'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-25.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_25" :visible="col == 'col1_25'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p>
                                      {{ $t("help.faqs.frequently-asked-questions.question-25.answer-part-1") }}
                                    </p>

                                    <p>
                                      <a href="/account">
                                        <i class="bx bx-support"></i>
                                        {{ $t("help.faqs.frequently-asked-questions.question-25.answer-part-2") }}
                                      </a>
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1_26' ? 'founded' : ''" v-b-toggle="'col1_26'">
                                    <div>
                                      {{ $t("help.faqs.frequently-asked-questions.question-26.text") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col1_26" :visible="col == 'col1_26'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p>
                                      {{ $t("help.faqs.frequently-asked-questions.question-26.answer-part-1") }}
                                    </p>

                                    <p>
                                      <a href="/help-center/support">
                                        <i class="bx bx-support"></i>
                                        {{ $t("help.faqs.frequently-asked-questions.question-26.answer-part-2") }}
                                      </a>
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                            </div>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>

                    <b-tab :active="cat == 'cat2'">
                      <template v-slot:title>
                        <i class="bx bx-bug-alt nav-icon d-block mb-2"></i>
                        <p class="font-weight-bold mb-0">
                          {{ $t("help.faqs.error-messages.text") }}
                        </p>
                      </template>
                      <b-card-text>
                        <div class="card">
                          <div class="card-body">
                            <h4 class="card-title mb-4">
                              {{ $t("help.faqs.error-messages.common-error-messages.text") }}
                            </h4>
                            <div role="tablist">
                              <b-card no-body class="custom-accordion shadow-none mb-3s">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list" :class="col == 'col2_5' ? 'founded' : ''" v-b-toggle="'col2_5'">
                                    <div>
                                      {{ $t("help.faqs.error-messages.common-error-messages.error-5.text-1") }}
                                      <!-- {{ $t("help.faqs.error-messages.common-error-messages.error-5.text-2") }} -->
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col2_5" :visible="col == 'col2_5'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <b-card-text>
                                      <p class="mb-3">
                                        {{ $t("help.faqs.error-messages.common-error-messages.error-5.solution-1") }}
                                      </p>
                                      <p>
                                        <a href="/help-center/support">
                                          <i class="bx bx-support"></i>
                                          {{ $t("help.faqs.error-messages.common-error-messages.error-5.solution-4") }}
                                        </a>
                                      </p>
                                    </b-card-text>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col2_3' ? 'founded' : ''" v-b-toggle="'col2_3'">
                                    <div>
                                      {{ $t("help.faqs.error-messages.common-error-messages.error-3.text-1") }}
                                      <!-- {{ $t("help.faqs.error-messages.common-error-messages.error-3.text-2") }} -->
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col2_3" :visible="col == 'col2_3'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p class="mb-0">
                                      {{ $t("help.faqs.error-messages.common-error-messages.error-3.solution-1") }}
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list" :class="col == 'col2_1' ? 'founded' : ''" v-b-toggle="'col2_1'">
                                    <div>
                                      <u> {{ $t("help.faqs.error-messages.common-error-messages.error-1.text-1") }}</u>
                                      {{ $t("help.faqs.error-messages.common-error-messages.error-1.text-2") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col2_1" :visible="col == 'col2_1'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <b-card-text>
                                      <p class="mb-0">
                                        {{ $t("help.faqs.error-messages.common-error-messages.error-1.solution-1") }}
                                      </p>
                                    </b-card-text>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>

                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col2_2' ? 'founded' : ''" v-b-toggle="'col2_2'">
                                    <div>
                                      <u> {{ $t("help.faqs.error-messages.common-error-messages.error-2.text-1") }}</u>
                                      {{ $t("help.faqs.error-messages.common-error-messages.error-2.text-2") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col2_2" :visible="col == 'col2_2'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <p class="mb-0">
                                      {{ $t("help.faqs.error-messages.common-error-messages.error-2.solution-1") }}
                                    </p>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>

                              <b-card no-body class="custom-accordion shadow-none mb-3">
                                <b-card-header header-tag="header" role="tab">
                                  <a href="javascript: void(0);" class="accordion-list" :class="col == 'col2_4' ? 'founded' : ''" v-b-toggle="'col2_4'">
                                    <div>
                                      <u> {{ $t("help.faqs.error-messages.common-error-messages.error-4.text-1") }}</u>
                                      {{ $t("help.faqs.error-messages.common-error-messages.error-4.text-2") }}
                                    </div>
                                    <i class="mdi mdi-minus accor-plus-icon"></i>
                                  </a>
                                </b-card-header>
                                <b-collapse id="col2_4" :visible="col == 'col2_4'" accordion="general-accordion" role="tabpanel">
                                  <b-card-body>
                                    <b-card-text>
                                      <p class="mb-3">
                                        {{ $t("help.faqs.error-messages.common-error-messages.error-4.solution-1") }}
                                      </p>
                                      <p>
                                        <a href="/help-center/support">
                                          <i class="bx bx-support"></i>
                                          {{ $t("help.faqs.error-messages.common-error-messages.error-4.solution-2") }}
                                        </a>
                                      </p>
                                    </b-card-text>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                            </div>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <!-- <b-tab :active="cat == 'cat4'">
                      <template v-slot:title>
                        <i class="bx bxs-graduation nav-icon d-block mb-2"></i>
                        <p class="font-weight-bold mb-0">
                          {{ $t("help.faqs.contact-page.go") }}
                        </p>
                      </template>
                    </b-tab> -->
                    <b-tab :active="cat == 'cat3'">
                      <template v-slot:title>
                        <i class="bx bxs-graduation nav-icon d-block mb-2"></i>
                        <p class="font-weight-bold mb-0">
                          {{ $t("help.faqs.kvkk-definitions.text") }}
                        </p>
                      </template>
                      <b-card-text>
                        <div class="card">
                          <div class="card-body">
                            <h4 class="card-title mb-4">
                              {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.text") }}
                            </h4>
                            <div role="tablist">
                              <p>
                                <b :class="col == 'col3_1' ? 'founded' : ''">
                                  {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.key-1") }}
                                  :
                                </b>
                                {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.value-1") }}
                              </p>
                              <p>
                                <b :class="col == 'col3_2' ? 'founded' : ''">
                                  {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.key-2") }}
                                  :
                                </b>
                                {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.value-2") }}
                              </p>

                              <p>
                                <b :class="col == 'col3_3' ? 'founded' : ''">
                                  {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.key-3") }}
                                  :
                                </b>
                                {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.value-3") }}
                              </p>
                              <p>
                                <b :class="col == 'col3_4' ? 'founded' : ''">
                                  {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.key-4") }}
                                  :
                                </b>
                                {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.value-4") }}
                              </p>

                              <p>
                                <b :class="col == 'col3_5' ? 'founded' : ''">
                                  {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.key-5") }}
                                  :
                                </b>
                                {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.value-5") }}
                              </p>
                              <p>
                                <b :class="col == 'col3_6' ? 'founded' : ''">
                                  {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.key-6") }}
                                  :
                                </b>
                                {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.value-6") }}
                              </p>
                              <p>
                                <b :class="col == 'col3_7' ? 'founded' : ''">
                                  {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.key-7") }}
                                  :
                                </b>
                                {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.value-7") }}
                              </p>
                              <p>
                                <b :class="col == 'col3_8' ? 'founded' : ''">
                                  {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.key-8") }}
                                  :
                                </b>
                                {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.value-8") }}
                              </p>

                              <p>
                                <b :class="col == 'col3_9' ? 'founded' : ''">
                                  {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.key-9") }}
                                  :
                                </b>
                                {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.value-9") }}
                              </p>
                              <p>
                                <b :class="col == 'col3_10' ? 'founded' : ''">
                                  {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.key-10") }}
                                  :
                                </b>
                                {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.value-10") }}
                              </p>
                              <p>
                                <b :class="col == 'col3_11' ? 'founded' : ''">
                                  {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.key-11") }}
                                  :</b
                                >
                                {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.value-11") }}
                              </p>
                              <p>
                                <b :class="col == 'col3_12' ? 'founded' : ''">
                                  {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.key-12") }}
                                  :
                                </b>
                                {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.value-12") }}
                              </p>
                              <p>
                                <b :class="col == 'col3_13' ? 'founded' : ''">
                                  {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.key-13") }}
                                  :
                                </b>
                                {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.value-13") }}
                              </p>
                              <p>
                                <b :class="col == 'col3_14' ? 'founded' : ''">
                                  {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.key-14") }}
                                  :
                                </b>
                                {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.value-14") }}
                              </p>
                              <p>
                                <b :class="col == 'col3_15' ? 'founded' : ''">
                                  {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.key-15") }}
                                  :
                                </b>
                                {{ $t("help.faqs.kvkk-definitions.common-kvkk-definitions.value-15") }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab :active="cat == 'cat4'">
                      <template v-slot:title>
                        <i class="bx bxs-graduation nav-icon d-block mb-2"></i>
                        <p class="font-weight-bold mb-0">
                          {{ $t("help.faqs.bgys-definitions.text") }}
                        </p>
                      </template>
                      <b-card-text>
                        <div class="card">
                          <div class="card-body">
                            <h4 class="card-title mb-4">
                              {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.text") }}
                            </h4>
                            <div role="tablist">
                              <p>
                                <b :class="col == 'col5_1' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-1") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-1") }}
                              </p>
                              <p>
                                <b :class="col == 'col5_2' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-2") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-2") }}
                              </p>

                              <p>
                                <b :class="col == 'col5_3' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-3") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-3") }}
                              </p>
                              <p>
                                <b :class="col == 'col5_4' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-4") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-4") }}
                              </p>

                              <p>
                                <b :class="col == 'col5_5' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-5") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-5") }}
                              </p>
                              <p>
                                <b :class="col == 'col5_6' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-6") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-6") }}
                              </p>
                              <p>
                                <b :class="col == 'col5_7' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-7") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-7") }}
                              </p>
                              <p>
                                <b :class="col == 'col5_8' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-8") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-8") }}
                              </p>

                              <p>
                                <b :class="col == 'col5_9' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-9") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-9") }}
                              </p>
                              <p>
                                <b :class="col == 'col5_10' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-10") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-10") }}
                              </p>
                              <p>
                                <b :class="col == 'col5_11' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-11") }}
                                  :</b
                                >
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-11") }}
                              </p>
                              <p>
                                <b :class="col == 'col5_12' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-12") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-12") }}
                              </p>
                              <p>
                                <b :class="col == 'col5_13' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-13") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-13") }}
                              </p>
                              <p>
                                <b :class="col == 'col5_14' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-14") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-14") }}
                              </p>
                              <p>
                                <b :class="col == 'col5_15' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-15") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-15") }}
                              </p>
                              <p>
                                <b :class="col == 'col5_16' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-16") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-16") }}
                              </p>
                              <p>
                                <b :class="col == 'col5_17' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-17") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-17") }}
                              </p>
                              <p>
                                <b :class="col == 'col5_18' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-18") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-18") }}
                              </p>
                              <p>
                                <b :class="col == 'col5_19' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-19") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-19") }}
                              </p>

                              <p>
                                <b :class="col == 'col5_20' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-20") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-20") }}
                              </p>

                              <ul>
                                <li>
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-20-1") }}
                                </li>
                              </ul>

                              <p>
                                <b :class="col == 'col5_21' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-21") }}
                                  :
                                </b>
                              </p>

                              <ul>
                                <li>
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-21") }}

                                  <ul>
                                    <li>
                                      {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-21-1") }}
                                    </li>
                                  </ul>
                                </li>
                                <li>
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-21-2") }}

                                  <ul>
                                    <li>
                                      {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-21-3") }}
                                    </li>
                                  </ul>
                                </li>
                              </ul>

                              <p>
                                <b :class="col == 'col5_22' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-22") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-22") }}
                              </p>
                              <p>
                                <b :class="col == 'col5_23' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-23") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-23") }}
                              </p>
                              <p>
                                <b :class="col == 'col5_24' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-24") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-24") }}
                              </p>
                              <p>
                                <b :class="col == 'col5_25' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-25") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-25") }}
                              </p>
                              <p>
                                <b :class="col == 'col5_26' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-26") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-26") }}
                              </p>
                              <p>
                                <b :class="col == 'col5_27' ? 'founded' : ''">
                                  {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.key-27") }}
                                  :
                                </b>
                                {{ $t("help.faqs.bgys-definitions.common-bgys-definitions.value-27") }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                  </b-tabs>
                  <!--Tab Category End-->
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- end Faqs start -->
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cat: "cat1",
      col: "col1_1",
    };
  },
  mounted() {
    setTimeout(() => {
      const { cat, col } = this.$route.query;
      this.cat = cat;
      this.col = col;
      window.scrollTo({ top: 700, behavior: "smooth" });
    }, 500);
  },
  methods: {},
};
</script>

<style scoped>
.founded {
  background: yellow !important;
}
</style>
